import {NFTStorage, File} from 'nft.storage';

const symbol = 'TUT';

const apiKey =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDliM0I5ZmUxMEY5MENiNGQyNzJDZTQxN0NlQjJlNDZmRUE3M2M5NTgiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY0NDcwMjI0NDk2OSwibmFtZSI6ImRpZ2l0YWxtIn0.r0kN-NxbciSh1Io0YmDaDTIbR_aRR0mwICt_DRJeL3M';
const client = new NFTStorage({token: apiKey});

const uploadToIpfs = async (name, description, imgFile) => {
    const metadata = await client.store({
        name: name,
        description: description,
        image: new File([imgFile], imgFile.name, {type: imgFile.type}),
        symbol: symbol,
        decimals: 0,
        shouldPreferSymbol: false,
        isBooleanAmount: true,
        artifactUri: new File([imgFile], imgFile.name, {type: imgFile.type}),
        displayUri: new File([imgFile], imgFile.name, {type: imgFile.type}),
        thumbnailUri: new File([imgFile], imgFile.name, {type: imgFile.type}),
        creators: ['digitalmassive'],
    });
    return metadata.url;
};

export {uploadToIpfs};
